import { OrderLookupContract } from 'models'
import integrationService from 'Services/api/integration.service'
import orderService from 'Services/api/order.service'
import productService from 'Services/api/product.service'
import createDispatchAction, {
    AppThunk,
    createDispatchActionSet,
    fetchWithNotification,
} from './base.action'
import { searchOrderRequest } from './orderLookup.action'

export const getOrderQueuesActions = createDispatchActionSet<any>(
    'GET_ORDER_QUEUES',
)
export const ORDER_QUEUE_ADD_ORDER = 'ORDER_QUEUE_ADD_ORDER'
export const ORDER_QUEUE_UPDATE_ORDER_STATUS = 'ORDER_QUEUE_UPDATE_ORDER_STATUS'
export const ORDER_QUEUE_UPDATE_PAYMENT_STATUS =
    'ORDER_QUEUE_UPDATE_PAYMENT_STATUS'
export const ORDER_QUEUE_CLEAR = 'ORDER_QUEUE_CLEAR'

export const getOrderQueues = (
    searchReq?: searchOrderRequest,
): AppThunk => async (dispatch) => {
    try {
        dispatch(getOrderQueuesActions.pending())

        const results = await fetchWithNotification({
            apiLinkFnc: () =>
                Promise.all([
                    orderService.searchOrders(searchReq!!),
                    productService.getProductLookupList(true),
                    integrationService.getLocationIntegrations(),
                ]),
        })
        const orders = results[0].data
        const products = results[1].data
        const locationIntegrations = results[2].data
        dispatch(
            getOrderQueuesActions.success({
                orders,
                products,
                locationIntegrations,
            }),
        )
    } catch (err) {
        dispatch(getOrderQueuesActions.failed(err))
    }
}

export const addOrderToOrderQueue = (order: OrderLookupContract) =>
    createDispatchAction(ORDER_QUEUE_ADD_ORDER, order)
export const updateOrderStatus = (order: OrderLookupContract) =>
    createDispatchAction(ORDER_QUEUE_UPDATE_ORDER_STATUS, order)
export const updatePaymentStatus = (order: OrderLookupContract) =>
    createDispatchAction(ORDER_QUEUE_UPDATE_PAYMENT_STATUS, order)
export const clearOrderQueue = () => createDispatchAction(ORDER_QUEUE_CLEAR)
